"use strict"

// 상품에 설정이 없으면 기존 고정 가격을 그대로 사용한다.
function quoteGroupProduct(product, persons, includePrivateSurcharge = false) {
  if (!product || product.groupPricing == null) return null
  const config = product.groupPricing
  const tiers = config && config.tiers
  const maximum = Number(product.maxpersons)
  if (product.type !== "group" || !Array.isArray(tiers) || !tiers.length ||
      !Number.isInteger(maximum) || maximum < 2 ||
      !["none", "earlyBird"].includes(config.fundingDiscount)) {
    throw new Error("INVALID_GROUP_PRICING")
  }
  let previousCount = 1
  let previousPrice = Infinity
  for (const tier of tiers) {
    if (!Number.isInteger(tier.fromPersons) || tier.fromPersons <= previousCount ||
        tier.fromPersons > maximum || !Number.isSafeInteger(tier.price) || tier.price < 0 ||
        tier.price > previousPrice) throw new Error("INVALID_GROUP_PRICING")
    previousCount = tier.fromPersons
    previousPrice = tier.price
  }
  if (tiers[0].fromPersons !== 2 || Number(product.price) !== tiers[0].price) {
    throw new Error("INVALID_GROUP_PRICING")
  }
  if (!Number.isInteger(persons) || persons < 2 || persons > maximum) {
    throw new Error("INVALID_GROUP_PERSONS")
  }
  const tier = tiers.filter(item => item.fromPersons <= persons).pop()
  const surcharge = includePrivateSurcharge && product.photoUsageConsent === false
    ? Math.max(0, Math.round(Number(product.photoUsagePrivateSurcharge) || 0)) : 0
  const unitPrice = tier.price + surcharge
  return { persons, unitPrice, totalPrice: unitPrice * persons }
}

module.exports = { quoteGroupProduct }
